import React, { useState } from "react";

import Button from "@material-ui/core/Button";

import moment from "moment";

import { Dialog } from "hooks/useDialog";

import {
  WebAsset,
  FileCopy,
  Share,
  Star as Upgrade,
  DeleteForever as Delete,
} from "@material-ui/icons";

import { hashHistory } from "browserHistory";
import { openConfirm } from "components/confirmBox/ConfirmBox";

const Portfolio = (props) => {
  const {
    portfolio,
    editorActions,
    shoppingCartActions,
    actions,
    useGuid,
    show = true,
    isFirst,
    isAdmin,
  } = props;

  const [showDialog, showDialog_set] = useState();

  if (!show) return <div />;

  return (
    <div key={`port_${portfolio.id}`}>
      <div style={{ padding: 10 }}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            {portfolio.name && (
              <div style={{ margin: 5 }}>Portfolio: {portfolio.name}</div>
            )}
            <div style={{ margin: 5, fontSize: 14 }}>
              Order Date:{" "}
              {moment.utc(portfolio.date).local().format("MMM Do, YYYY h:mm A")}
            </div>
            <div style={{ fontSize: 14, color: "#757575", margin: 5 }}>
              Analysis Period:{" "}
              {moment(portfolio.startDate).format("MMM Do, YYYY")} to{" "}
              {moment(portfolio.endDate).format("MMM Do, YYYY")}{" "}
            </div>
            {isAdmin && (
              <div style={{ marginTop: 20 }}>
                <Button
                  variant={"text"}
                  color={"primary"}
                  size={'small'}
                  onClick={() => {
                    window.open(`/#/Admin/Data/${portfolio.id}`, "_blank");
                  }}
                >
                  Calcs1 Data (Admin Only)
                </Button>
              </div>
            )}
          </div>
          <div style={{ width: isFirst ? 130 : 80 }}>
            <div
              style={{ whiteSpace: "nowrap", textAlign: "right" }}
              title={"View Report"}
            >
              <Button
                fullWidth
                variant={"outlined"}
                color={"primary"}
                onClick={() => {
                  window.open(
                    `/#/Portfolio/${
                      useGuid ? portfolio.uniqueId : portfolio.id
                    }`,
                    "_blank"
                  );
                }}
              >
                {" "}
                <WebAsset
                  style={{ marginRight: isFirst ? 10 : "default" }}
                />{" "}
                {isFirst ? "View" : ""}
              </Button>
            </div>
            {!useGuid && (
              <div
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                  marginTop: 10,
                }}
                title={"Share Portfolio Report"}
              >
                <Button
                  fullWidth
                  variant={"outlined"}
                  color={"primary"}
                  onClick={() => {
                    showDialog_set(true);
                  }}
                >
                  {" "}
                  <Share
                    style={{ marginRight: isFirst ? 10 : "default" }}
                  />{" "}
                  {isFirst ? "Share" : ""}
                </Button>
              </div>
            )}
            {editorActions && (
              <div
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                  marginTop: 10,
                }}
                title={"Copy Portfolio"}
              >
                <Button
                  fullWidth
                  variant={"outlined"}
                  color={"primary"}
                  onClick={() => {
                    editorActions.copyPortfolio(portfolio.id, () => {
                      hashHistory.push("/DataEntry/Edit");
                    });
                  }}
                >
                  {" "}
                  <FileCopy style={{ marginRight: isFirst ? 10 : "default" }} />
                  {isFirst ? "Copy" : ""}
                </Button>
              </div>
            )}
            {editorActions && (
              <div
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                  marginTop: 10,
                }}
                title={"Delete Portfolio"}
              >
                <Button
                  fullWidth
                  variant={"outlined"}
                  color={"primary"}
                  onClick={() => {
                    openConfirm({
                      title: "Confirm Deletion",
                      description: (
                        <div>
                          <div>
                            Are you sure you want to permanently delete this
                            portfolio?
                          </div>
                          <div style={{ fontWeight: "bold", marginTop: 20 }}>
                            This cannot be undone.
                          </div>
                          <div style={{ marginTop: 20 }}>
                            Make sure to download a copy first by viewing the
                            report and printing it to a PDF file.
                          </div>
                        </div>
                      ),
                      callback: () => {
                        actions.deletePortfolio(portfolio.id, null, () => {});
                      },
                    });
                  }}
                >
                  {" "}
                  <Delete style={{ marginRight: isFirst ? 10 : "default" }} />
                  {isFirst ? "Delete" : ""}
                </Button>
              </div>
            )}
          </div>
        </div>
        {showDialog && (
          <div>
            <Dialog title={"Public Link"} onClose={() => showDialog_set(false)}>
              <div style={{ fontSize: 14 }}>
                <div>
                  Here is a direct link to your report. This link will allow
                  others to see this report. It is publicly available, so only
                  share it with those you trust.
                </div>
                <div
                  style={{ marginTop: 10, color: "#5a5aff" }}
                  id="linkCopy"
                >{`${window.location.protocol}//${window.location.host}/#/Portfolio/${portfolio.uniqueId}`}</div>
                <div style={{ marginTop: 10 }}>
                  <Button
                    color={"primary"}
                    variant="outlined"
                    onClick={() => {
                      var range = document.createRange();
                      range.selectNode(document.getElementById("linkCopy"));
                      window.getSelection().removeAllRanges(); // clear current selection
                      window.getSelection().addRange(range); // to select text
                      document.execCommand("copy");
                      window.getSelection().removeAllRanges(); // to deselect
                    }}
                  >
                    Copy Link
                  </Button>
                </div>
              </div>
            </Dialog>
          </div>
        )}
        {useGuid && (
          <div
            style={{
              margin: 10,
              padding: 10,
              borderRadius: 5,
              backgroundColor: "#daebff",
              border: "1px solid #6b7fff",
            }}
          >
            <div style={{ fontSize: 16, margin: 5 }}>Analysis Direct Link</div>
            <div style={{ fontSize: 14, margin: 5 }}>
              Here is the direct link to your report. Do not lose it as it is
              the only way to access your report!
            </div>
            <div
              style={{ marginTop: 10, marginBottom: 10, marginLeft: 5 }}
            >{`${window.location.protocol}//${window.location.host}/#/Portfolio/${portfolio.uniqueId}`}</div>
            <div style={{ fontSize: 12, margin: 5 }}>
              Note: This link will also be sent to your email, as part of your
              receipt.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Portfolio;



// WEBPACK FOOTER //
// ./src/account/components/Portfolio.js